import { useApolloClient } from '@apollo/react-hooks';
import { EditInPreviewRsvpSettings, RSVPSettingsRightRail } from '../../libs/component-rsvp-settings';
import { GuestWedding } from '../../libs/component-rsvp-settings/GuestWeddingTypes';
import { GuestWeddingResponse, Household } from '../../libs/gds-api-client';
import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { EventType } from '../../libs/component-rsvp-settings/EventTypes';
import {
  useEventsQuery,
  useHouseholdQuery,
  useWeddingWebsiteQuery,
  WeddingWebsiteQuery,
} from '../../generated/graphql';
import { guestListEventRoute, manageRsvpSettingsRoute, rsvpSettingsRoute } from '../../helpers/routes';
import { useHasPrivateEvent } from '../../helpers/useHasPrivateEvent';
import { useRsvpOncount } from '../../helpers/useRvspOnCount';
import { weddingWebsiteQuery } from '../Dashboard';
import { guestWeddingWithTypename } from '../RsvpSettingsPage/helper';

interface Props {
  onSaveSuccess: () => void;
  onClose: () => void;
  preview?: boolean;
  leftButtonOnClick?: () => void;
}

export const ManageRsvpSettingsRail: React.FC<Props> = ({ preview, onClose, onSaveSuccess, leftButtonOnClick }) => {
  const { data } = useWeddingWebsiteQuery();
  const { data: eventsData } = useEventsQuery();
  const { data: householdData } = useHouseholdQuery();
  const rsvpOnCount = useRsvpOncount();
  const hasPrivateEvent = useHasPrivateEvent();
  const history = useHistory();
  const match = useRouteMatch(manageRsvpSettingsRoute(preview));
  const client = useApolloClient();

  const onCloseClick = () => {
    onClose();
  };

  const onSuccess = (response: GuestWeddingResponse) => {
    const { guestWedding, ...rest } = client.readQuery<WeddingWebsiteQuery>({ query: weddingWebsiteQuery })!;

    const updated = guestWeddingWithTypename(guestWedding, response);
    client.writeQuery({
      query: weddingWebsiteQuery,
      data: { guestWedding: updated, ...rest },
    });
    onSaveSuccess();
  };

  const onClickEditForm = () => history.push(rsvpSettingsRoute);

  const rsvpSettingProps = {
    rsvpOnInEvents: rsvpOnCount > 0,
    wwsState: data?.weddingWebsite.state || '',
    guestWedding: data?.guestWedding as GuestWedding,
    hasPrivateEvent,
    onClickEditForm,
    onClose: onCloseClick,
    onSuccess,
  };

  if (preview) {
    // show RSVP Visuals when RSVP is visible and any guest
    return (
      <EditInPreviewRsvpSettings
        editInPreview
        leftButtonOnClick={leftButtonOnClick}
        showVisualization={data?.guestWedding?.rsvpPageHidden === false}
        events={eventsData?.events as EventType[]}
        households={householdData?.households as Household[]}
        openEventModal={id => {
          history.push(guestListEventRoute(id));
        }}
        {...rsvpSettingProps}
      />
    );
  }

  return <RSVPSettingsRightRail {...rsvpSettingProps} showRail={!!match} onEscapeKey={onClose} />;
};
